import "./AdvantagesList.css";

import servicesAppIcon1 from "../../../../Assets/Icons/services-app-icon1.svg";
import servicesAppIcon2 from "../../../../Assets/Icons/services-app-icon2.svg";
import servicesAppIcon3 from "../../../../Assets/Icons/services-app-icon3.svg";
import servicesAppIcon4 from "../../../../Assets/Icons/services-app-icon4.svg";
import servicesAppIcon5 from "../../../../Assets/Icons/services-app-icon5.svg";
import servicesAppIcon6 from "../../../../Assets/Icons/services-app-icon6.svg";

const AdvantagesList = () => {
  const advantages = [
    {
      id: "We Start With What Is Already Broken",
      icon: servicesAppIcon1,
      title: "We Start With What Is Already Broken",
      description:
        "Most clients arrive with pain points, half working systems, or user complaints. We begin by fixing reality, not pitching perfection.",
    },
    {
      id: "The Same Team Builds And Stays",
      icon: servicesAppIcon2,
      title: "The Same Team Builds And Stays",
      description:
        "Your mobile app is not passed between rotating developers. The same people stay, remember past decisions, and protect long term stability.",
    },
    {
      id: "We Design For Bad Networks First",
      icon: servicesAppIcon3,
      title: "We Design For Bad Networks First",
      description:
        "Apps are built assuming slow connections, interruptions, and real usage in markets like Bangladesh, the UK, and Europe.",
    },
    {
      id: "Decisions Are Explained In Plain Language",
      icon: servicesAppIcon4,
      title: "Decisions Are Explained In Plain Language",
      description:
        "When tradeoffs appear, we explain them simply so product owners feel confident, not confused or pushed into technical choices.",
    },
    {
      id: "Performance Problems Are Addressed Early",
      icon: servicesAppIcon5,
      title: "Performance Problems Are Addressed Early",
      description:
        "We test load, responsiveness, and memory usage early, before real users expose issues that are expensive to fix later.",
    },
    {
      id: "After Launch Is Where We Show Up",
      icon: servicesAppIcon6,
      title: "After Launch Is Where We Show Up",
      description:
        "Most teams disappear after release. We stay involved, fixing edge cases, improving flows, and supporting growth once users arrive.",
    },
  ];

  return (
    <div className="advantages-list">
      {advantages.map((advantage) => (
        <div key={advantage.id} className="advantages-list__item">
          <div className="advantages-list__icon-wrapper">
            <img
              src={advantage.icon}
              alt={`${advantage.title} icon`}
              className="advantages-list__icon"
            />
          </div>
          <div className="advantages-list__text">
            <h3 className="advantages-list__title">{advantage.title}</h3>
            <p className="advantages-list__description">
              {advantage.description}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AdvantagesList;
